import React from 'react';
import ModalFrame from '../../dashboard/components/product_item_components/ModalFrame';
import '../../dashboard/Dashboard.css';
import { BUSINESS_VIEWS, businessViewById } from '../../../types/BusinessViewTypes';
import './BusinessViewField.css';

const GLYPH_BARS = {
  regular: 4,
  linear: 3,
  fashion: 3,
  magazine: 3,
};

function ViewGlyph({ kind }) {
  const count = GLYPH_BARS[kind] || 4;
  return (
    <span className={`shop-view-glyph shop-view-glyph--${kind}`} aria-hidden="true">
      {Array.from({ length: count }, (_, index) => (
        <span key={index} />
      ))}
    </span>
  );
}

export default function BusinessViewField({ viewType, onViewTypeChange, disabled }) {
  const [isOpen, setIsOpen] = React.useState(false);
  const selected = businessViewById(viewType);

  return (
    <section className="shop-create-section">
      <div className="shop-create-label">Вид витрины</div>
      <div className="shop-create-help">Как покупатели видят каталог</div>
      <button
        type="button"
        className="shop-view-button"
        onClick={() => setIsOpen(true)}
        disabled={disabled}
        aria-haspopup="dialog"
        aria-expanded={isOpen}
      >
        <ViewGlyph kind={selected.glyph} />
        <span className="shop-view-name">{selected.name}</span>
      </button>

      {isOpen ? (
        <ModalFrame title="Вид витрины" onClose={() => setIsOpen(false)}>
          <div className="main-page-modalList" role="listbox">
            {BUSINESS_VIEWS.map((view) => {
              const selectedOption = view.id === selected.id;
              return (
                <button
                  key={view.id}
                  type="button"
                  role="option"
                  aria-selected={selectedOption}
                  className={
                    selectedOption
                      ? 'main-page-modalItem main-page-modalItemSelected shop-view-option'
                      : 'main-page-modalItem shop-view-option'
                  }
                  onClick={() => {
                    onViewTypeChange?.(view.id);
                    setIsOpen(false);
                  }}
                >
                  <ViewGlyph kind={view.glyph} />
                  <span className="shop-view-name">{view.name}</span>
                </button>
              );
            })}
          </div>
        </ModalFrame>
      ) : null}
    </section>
  );
}
